var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import Input from '../BasicInput';
import PasswordStrengthIndicator from './PasswordStrengthIndicator';
import { getEvaluationLevelFromPassword, EvaluationLevel } from './validatePassword';
var ValidState;
(function (ValidState) {
    ValidState[ValidState["VALID"] = 0] = "VALID";
    ValidState[ValidState["TOO_LONG"] = 1] = "TOO_LONG";
    ValidState[ValidState["TOO_SHORT"] = 2] = "TOO_SHORT";
})(ValidState || (ValidState = {}));
var PasswordShowButton = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  line-height: 2rem;\n  cursor: pointer;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  color: ", ";\n"], ["\n  display: inline-block;\n  line-height: 2rem;\n  cursor: pointer;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  color: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.password.buttoncolor;
});
export var PasswordInput = function (_a) {
    var error = _a.error, onError = _a.onError, onValid = _a.onValid, onChange = _a.onChange, _b = _a.lengthMinMax, lengthMinMax = _b === void 0 ? [6, 15] : _b, _c = _a.checkPasswordStrength, checkPasswordStrength = _c === void 0 ? false : _c, onEvaluation = _a.onEvaluation, _d = _a.validate, validate = _d === void 0 ? true : _d, props = __rest(_a, ["error", "onError", "onValid", "onChange", "lengthMinMax", "checkPasswordStrength", "onEvaluation", "validate"]);
    var _e = useState('password'), inputType = _e[0], setInputType = _e[1];
    var _f = useState(ValidState.VALID), validState = _f[0], setValidState = _f[1];
    var _g = useState(''), password = _g[0], setPassword = _g[1];
    var minLength = lengthMinMax[0], maxLength = lengthMinMax[1];
    var level = useMemo(function () { return getEvaluationLevelFromPassword(password, minLength, maxLength); }, [
        password,
        minLength,
        maxLength,
    ]);
    useEffect(function () {
        if (typeof onEvaluation === 'function') {
            onEvaluation(level);
        }
        if (password !== '' && validate) {
            if (level === EvaluationLevel.TOO_SHORT) {
                setValidState(ValidState.TOO_SHORT);
            }
            else if (level === EvaluationLevel.TOO_LONG) {
                setValidState(ValidState.TOO_LONG);
            }
            else {
                setValidState(ValidState.VALID);
            }
        }
        else {
            setValidState(ValidState.VALID);
        }
    }, [password, level, validate]);
    useEffect(function () {
        if (validState === ValidState.VALID && onValid) {
            onValid();
        }
        else if (validState !== ValidState.VALID && onError) {
            onError();
        }
    }, [validState, onError, onValid]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, __assign({ "data-testid": "form-controls-input" }, props, { error: error ||
                (validState === ValidState.TOO_LONG ? (React.createElement(FormattedMessage, { defaultMessage: "Your password is too long", id: "PasswordInput.Password.too_long" })) : validState === ValidState.TOO_SHORT ? (React.createElement(FormattedMessage, { defaultMessage: "Your password is too short", id: "PasswordInput.Password.too_short" })) : undefined), onChange: function (event) {
                setPassword(event.target.value);
                if (onChange) {
                    onChange(event);
                }
            }, buttonContent: inputType === 'password' ? (React.createElement(PasswordShowButton, { "data-testid": "form-controls-button", onClick: function () { return setInputType('text'); } },
                React.createElement(FormattedMessage, { defaultMessage: "show", id: "PasswordInput.ButtonLabel.ShowPassword" }))) : (React.createElement(PasswordShowButton, { "data-testid": "form-controls-button", onClick: function () { return setInputType('password'); } },
                React.createElement(FormattedMessage, { defaultMessage: "hide", id: "PasswordInput.ButtonLabel.HidePassword" }))), lengthMinMax: lengthMinMax, type: inputType, value: password })),
        checkPasswordStrength && React.createElement(PasswordStrengthIndicator, { level: level })));
};
export default PasswordInput;
var templateObject_1;
//# sourceMappingURL=index.js.map